import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { useState } from 'react';
import './styles/clientContainer.css';
import Policy from '../components/homepage/resources-policy/policy';
import Resourcesblog from '../components/homepage/resources-blog/blog';
import BlogDetails from '../components/homepage/resources-blogdetails/blogdetails';
import AboutUs from '../components/homepage/resources-about-us/about-us';
import ContactUs from '../components/homepage/resources-contact-us/contact-us';
import Navbarfaq from '../components/homepage/resources-FAQ/faq';
import ContactSales from '../components/homepage/contact-sales/contact-sales';
import NotificationDetails from '../components/notificationDetails/notificationDetails';
import { CandidateProfile } from '../components/candidates/candidateProfile/candidateProfile';
import CandidatePostDashboard from '../components/candidates/candidatePostDashboard/candidatePostDashboard';
import { CandidateDetails } from '../components/candidates/candidateDetails/candidateDetail';
import CandidateValueAdd from '../components/candidates/candidateValueAdd/candidateValueAdd';
import CandidateResetPassword from '../components/candidates/candidateResetPassword/passwordReset';
import CandidateHeader from '../components/candidates/candidateHeader/candidateHeader';
import CandidateFooter from '../components/candidates/candidateFooter/candidateFooter';
import { CandidateUserProvider } from '../components/candidates/candidateUserContext/candidateUserContext';
import PsychometricDashboard from '../components/candidates/psychometricDashboard/psychometricDashboard';
import CandidateJobSearch from '../components/candidates/candidateValueAdd/CandidateJobSearch';
import CandidatePostLoginValueAdd from '../components/candidates/candidatePostLoginValueAdd/candidatePostLoginValueAdd';
import TermsConsentModal from '../components/candidates/terms-consent-modal/termsConsentModal';

export const CandidateContainer = () => {

    const [termsStatus, setTermsStatus] = useState(
        localStorage.getItem('termsStatus')
    );

    let location;
    try {
        location = useLocation();
    } catch (e) {
        return (
            <BrowserRouter>
                <CandidateContainer />
            </BrowserRouter>
        );
    }

    const needsTermsConsent =
        !termsStatus || termsStatus === 'DECLINED';

    const handleTermsAccepted = () => {
        localStorage.setItem('termsStatus', 'ACCEPTED');
        setTermsStatus('ACCEPTED');
    };

    // Show ONLY the Terms popup
    // until the candidate accepts.
    if (needsTermsConsent) {
        return (
            <TermsConsentModal
                show={true}
                onAccepted={handleTermsAccepted}
            />
        );
    }

    return (
        <>
            <CandidateUserProvider>
                <div className="candidate-layout">
                    <CandidateHeader />

                    <div className="candidate-content fluid-container">

                        <Row>
                            <Col className="contentPane">

                                <Routes>
                                    <Route path="/" element={<Navigate to="/candidate/profile" />} />
                                    <Route path='/candidate/dashboard' element={<CandidatePostDashboard />} />
                                    <Route path='/candidate/details' element={<CandidateDetails />} />
                                    <Route path='/candidate/jobs' element={<CandidateValueAdd />} />
                                    <Route path='/candidate/value-add' element={<CandidatePostLoginValueAdd />} />
                                    <Route path="/candidate/job-search" element={<CandidateJobSearch />} />
                                    <Route path='/candidate/password-reset' element={<CandidateResetPassword />} />
                                    <Route path='/candidate/profile' element={<CandidateProfile />} />
                                    <Route path="/" element={<Navigate to="/candidate/profile" />} />
                                    <Route path='/candidate/psychometric-test/dashboard' element={<PsychometricDashboard />} />
                                    <Route path='/notification-details' element={<NotificationDetails />} />
                                    <Route path='/contact-sales' element={<ContactSales />} />
                                    <Route path="/resources-blog" element={<Resourcesblog />} />
                                    <Route path="/navbar-faq" element={<Navbarfaq />} />
                                    <Route path="/about-us" element={<AboutUs />} />
                                    <Route path="/blogdetails" element={<BlogDetails />} />
                                    <Route path="/policy" element={<Policy />} />
                                    <Route path="/contact-us" element={<ContactUs />} />
                                </Routes>

                            </Col>
                        </Row>
                    </div>
                    <CandidateFooter />
                </div>
            </CandidateUserProvider>
        </>
    );
};
